import { RECORDER_STATES } from '../helpers.js'

let RECORDER_STATES_TO_VIEW = {
  [RECORDER_STATES.INITIAL]: 'Initial',
  [RECORDER_STATES.STARTING]: 'Starting',
  [RECORDER_STATES.RECORDING]: 'Recording',
  [RECORDER_STATES.PAUSED]: 'Paused',
  [RECORDER_STATES.ENCODING]: 'Encoding',
  [RECORDER_STATES.COMPLETE]: 'Initial',
  [RECORDER_STATES.ERROR]: 'Error',
}

export function getView(state) {
  return RECORDER_STATES_TO_VIEW[state] || 'No'
}
